import "./widget.scss";
import { Link } from "react-router-dom";

const Widget = ({ type, data }) => {
  let widgetData;
  switch (type) {
    case "user":
      widgetData = {
        title: "All Customers",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all customers",
        linkto: "/customers",
        total: data,
      };
      break;
    case "order":
      widgetData = {
        title: "Products",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all products",
        linkto: "/products",
        total: data,
      };
      break;
    case "earning":
      widgetData = {
        title: "Suppliers",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all suppliers",
        linkto: "/supplier",
        total: data,
      };
      break;
    case "balance":
      widgetData = {
        title: "All Orders",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all orders",
        linkto: "/order",
        total: data,
      };
      break;
    case "newcustomer":
      widgetData = {
        title: "New Customers",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all new customer",
        linkto: "/customers?type=new",
        total: data,
      };
      break;
    case "selling":
      widgetData = {
        title: "Active Order",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all Active Order",
        linkto: "/order?type=active",
        total: data,
      };
      break;
    case "allorders":
      widgetData = {
        title: "All Orders",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all Order",
        linkto: "/order",
        total: data,
      };
      break;
    case "activeorder":
      widgetData = {
        title: "Active Order",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all Active Order",
        linkto: "/order?type=active",
        total: data,
      };
      break;
    case "deliveredorder":
      widgetData = {
        title: "Delivered Order",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all Delivered Order",
        linkto: "/order?type=deliver",
        total: data,
      };
      break;
    case "outfordelivery":
      widgetData = {
        title: "Out for Delivery",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View all Out for Delivery",
        linkto: "/order?type=outfordelivery",
        total: data,
      };
      break;
    case "totalsale":
      widgetData = {
        title: "Total Sale",
        isMoney: true,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View sales details",
        linkto: "/purchase-order",
        total: data,
      };
      break;
    case "todaytotalsale":
      widgetData = {
        title: "Today's Total Sale",
        isMoney: true,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View today's sales",
        linkto: "/purchase-order?type=today",
        total: data,
      };
      break;
    case "topusers":
      widgetData = {
        title: "Top Users",
        isMoney: false,
        bgcolor: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        link: "View top users",
        linkto: "/customers?type=top",
        total: data,
      };
      break;
    default:
      break;
  }

  return (
    <div className="widget ml-3" style={{ backgroundImage: widgetData.bgcolor }}>
      <div className="left">
        <span className="title">{widgetData.title}</span>
        <span className="counter">
          {widgetData.isMoney && "₹"} {widgetData.total}
        </span>
        <Link style={{ textDecoration: "none", color: "grey" }} to={widgetData.linkto}>
          <span className="link">{widgetData.link}</span>
        </Link>
      </div>
      <div className="right">
        <div className="percentage positive"></div>
        {widgetData.icon}
      </div>
    </div>
  );
};

export default Widget;